export default __webpack_public_path__ + "static/media/welcome.974db2e6.PNG";